/**
 * Slideshow
 *
 * * @param {string} selector - selector for slideshow elements
 */

import $ from 'jquery';

import { nextIcon, prevIcon } from './utils/icons';

export const stageSlider = (selector = '.ghwp-slideshow') => {
    const getButton = (direction, icon) =>
        `<button type="button" class="slick-${direction}">${icon}</button>`;

    // Slideshow in a stage
    $(selector).slick({
        autoplay: true,
        autoplaySpeed: 5500,
        arrows: true,
        prevArrow: getButton('prev', prevIcon),
        nextArrow: getButton('next', nextIcon),
        fade: true,
        speed: 1000,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                },
            },
        ],
    });
    // Add events for animation
    const items = $(selector).find('.slick-slide');
    $(items[0]).addClass('animated');
    $(selector).on('afterChange', function(event, slick, nextSlide) {
        let currentSlide = nextSlide - 1;
        if (currentSlide < 0) {
            currentSlide = items.length - 1;
        }
        $(items[currentSlide]).removeClass('animated');
    });
    $(selector).on('beforeChange', function(event, slick, currentSlide) {
        let nextSlide = currentSlide + 1;
        if (nextSlide >= items.length) {
            nextSlide = 0;
        }
        $(items[nextSlide]).addClass('animated');
    });
};

export const carouselSlider = (selector = '.ghwp-carousel') => {
    const getButton = (direction, icon) =>
        `<button type="button" class="slick-${direction}">${icon}</button>`;

    // Testimonial slideshow
    $(selector).slick({
        arrows: true,
        prevArrow: getButton('prev', prevIcon),
        nextArrow: getButton('next', nextIcon),
        autoplay: true,
        pauseOnHover: true,
        pauseOnDotsHover: true,
        dots: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                },
            },
        ],
    });

    $(selector).each(function() {
        const slidesShown = parseInt(
            $(this).data('ghwp-slick-slide-count'),
            10
        );
        $(this).slick('slickSetOption', 'slidesToShow', slidesShown);
        $(this).slick('slickSetOption', 'slidesToScroll', slidesShown, true);
    });
};
